import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import HeroModule from "../components/home/HeroModule";
import Testimonial from "../components/home/Testimonials";
import ServicesModule from "../components/service/ServicesModule";
import ProductsGrid from "../components/product/ProductsGrid";
import Seo from "../components/generic/Seo";

const Home = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const navigate = useNavigate();

  // Update isMobile on window resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const buttonStyle = {
    alignItems: "center",
    padding: "12px 20px",
    background: "linear-gradient(45deg, #653b93, #11d3f1)",
    border: "0",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "transform 0.3s",
    transform: isHovered ? "scale(1.05)" : "scale(1)",
    alignSelf: isMobile ? "center" : "auto", // center on mobile
  };

  const objSeo = {
    title: "Springevening Private Limited - Empowering Your Digital Journey",
    keywords:
      "startup, Software company, Soochi ERP, HappyNenapu, Flipbook, Brand reflection,Maximizing brand reach,SEO optimization,Empowering developers, Training, Internship, Bagalkot, BEC, sedamkar, North Karnataka",
    pathSlug: "",
    description:
      "Our innovative software company specializes in crafting captivating digital experiences that reflect your brand and exceed expectations. We maximize your brand's reach, engagement, and conversions through strategic digital campaigns and meticulous SEO optimization. Additionally, we empower aspiring developers with the tools and knowledge to thrive in the dynamic world of software engineering.",
  };

  return (
    <>
      <Seo data={objSeo} />
      <section style={{ marginBottom: "180px" }}>
        <HeroModule />
      </section>

      <section id="ServiceModule" style={{ marginBottom: "180px" }}>
        <ServicesModule />
      </section>

      <section style={{ marginBottom: "80px" }}>
        <ProductsGrid />
      </section>

      <section>
        <Testimonial />
      </section>

      {/* Contact Button Section */}
      <section style={{ marginBottom: isMobile ? "100px" : "0px" }}>
        <div
          style={{
            padding: isMobile ? "20px 15px" : "20px 40px",
            display: "flex",
            flexDirection: isMobile ? "column" : "row", // stack on mobile
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "8px",
            maxWidth: "900px",
            margin: "40px auto",
            gap: isMobile ? "20px" : "0", // space between stacked items
          }}
        >
          <div
            style={{
              color: "white",
              fontWeight: 800,
              fontSize: isMobile ? "24px" : "36px",
              lineHeight: 1.3,
              textAlign: isMobile ? "center" : "left", // center on mobile
            }}
          >
            <span className="text-accent">Contact</span> us for the service{" "}
            <br />
            <strong>you want to use</strong>
          </div>

          <button
            style={buttonStyle}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onClick={() => navigate("/contactus")}
          >
            Contact us ↗
          </button>
        </div>
      </section>
    </>
  );
};

export default Home;
